import Translator from "./Translate";
import en from "../nonUSDefault.json";
import en_US from "../en_US.json";
import fr_CA from "../fr_CA.json";
import en_TW from "../en_TW.json";
import regionConstants from "./regionConstants";
import { GetAccountInformation } from "../../../store/service";

class I18nService {
    private translator: Translator = new Translator();

    public constructor() {
        this.translator.addLocale(en);
        this.translator.addLocale(en_US);
        this.translator.addLocale(fr_CA);
        this.translator.addLocale(en_TW);
        this.init();
    }

    public init(): void {
        this.translator.setLocale(regionConstants.Region.en);
        GetAccountInformation().then((data: any) => {
            const country = data?.["_unifiedAccountInfo"]?.country;
            if (country === "US") {
                this.translator.setLocale(regionConstants.Region.us);
            } else if (country === "CA") {
                this.translator.setLocale(regionConstants.Region.ca);
            } else if (country === "TW") {
                this.translator.setLocale(regionConstants.Region.tw);
            } else {
                this.translator.setLocale(regionConstants.Region.en);
            }
        });
    }

    public setRegionBasedonCountry(country: string | undefined) {
        if (country !== null && country !== undefined && country !== "") {
            if (country === "CA") {
                this.translator.setLocale(regionConstants.Region.ca);
            } else if (country === "US") {
                this.translator.setLocale(regionConstants.Region.us);
            } else if (country === "TW") {
                this.translator.setLocale(regionConstants.Region.tw);
            } else {
                this.translator.setLocale(regionConstants.Region.en);
            }
        } else {
            this.translator.setLocale(regionConstants.Region.us);
        }
    }

    public setRegion(isSupportInternational: boolean) {
        if (isSupportInternational) {
            const region = "en";
            if (region === regionConstants.Region.ca || region === regionConstants.Region.us) {
                this.translator.setLocale(region);
            } else {
                this.translator.setLocale(regionConstants.Region.en);
            }
        } else {
            this.translator.setLocale(regionConstants.Region.us);
        }
    }

    public get(key: string): any {
        if (!key) {
            throw new Error("Failed to retrieve i18n value for null key");
        }
        return this.translator.get(key);
    }

    public getRegion() {
        let region = "";
        return region;
    }
}

const i18nService = new I18nService();
export default i18nService;
